import * as React from 'react';
import { DoorIcon, PaletteIcon, EyedropperSampleIcon } from '@fronton/icons-react';
import {
  DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
  DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
  PictureTransformations,
} from 'common/components';
import { ENTRANCE_DOORS_CDN_LANDING_NAME } from '../../entrance-doors-constants';

export type EntranceDoorsGalleryPointStructure = {
  icon: React.ReactNode;
  text: string;
};

export type EntranceDoorsGalleryStructure = {
  alt: string;
  name: string;
  src: string;
  srcSmall: string;
  transformations?: PictureTransformations;
};

export const ENTRANCE_DOORS_GALLERY_POINTS_DATA: EntranceDoorsGalleryPointStructure[] = [
  {
    icon: <DoorIcon strokeWidth={0.85} type="duotone" size="40px" color="var(--secondary-orange_dark)" />,
    text: 'Сделаем стильное остекление',
  },
  {
    icon: <PaletteIcon strokeWidth={0.85} type="duotone" size="40px" color="var(--secondary-orange_dark)" />,
    text: 'Подберём нужный оттенок по\u00A0RAL',
  },
  {
    icon: (
      <EyedropperSampleIcon
        strokeWidth={0.85}
        type="duotone"
        size="40px"
        color="var(--secondary-orange_dark)"
      />
    ),
    text: 'Учтём стиль вашего дома',
  },
];

export const ENTRANCE_DOORS_GALLERY_LIST: EntranceDoorsGalleryStructure[] = Array(20)
  .fill(null)
  .map((_, index: number) => {
    const imageName = index + 1;
    const baseInfo = {
      alt: '',
      name: `${imageName}.jpg`,
      src: `${ENTRANCE_DOORS_CDN_LANDING_NAME}/gallery-popup/${imageName}.jpg/${imageName}.jpg`,
      srcSmall: `${ENTRANCE_DOORS_CDN_LANDING_NAME}/gallery/${imageName}.jpg/${imageName}.jpg`,
      transformations: DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
    };

    if (index % 10 === 4 || index % 10 === 7) {
      return {
        ...baseInfo,
        transformations: DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
      };
    }

    return baseInfo;
  });
